import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const responsibleConsumptionImporterSelectors = importerSelectors(
  'responsibleConsumption.importer',
);

export default responsibleConsumptionImporterSelectors;
